import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface AiImportReviewDialogData {
  hasNoteBuilderItems: boolean;
}

/**
 * Must-acknowledge popup shown right after an AI PDF import completes. Reminds the user that
 * AI-generated content needs review before publishing and calls out Note Builder logic when
 * present. Closes only via the "I Understand" button — no backdrop/Esc dismissal (see
 * disableClose in the caller's dialog.open config).
 */
@Component({
  standalone: false,
  selector: 'app-forms-builder-ai-import-review-dialog',
  templateUrl: './forms-builder-ai-import-review-dialog.component.html',
  styleUrls: ['./forms-builder-ai-import-review-dialog.component.scss']
})
export class FormsBuilderAiImportReviewDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<FormsBuilderAiImportReviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AiImportReviewDialogData) { }

  acknowledge(): void {
    this.dialogRef.close();
  }
}
